module.exports = __webpack_public_path__ + "img/9791185093437.c9e4bb1e.jpg";